module.exports = __webpack_public_path__ + "assets/img/session_bg1.157674a3.png";